import { render, staticRenderFns } from "./ModalSuprimentos.vue?vue&type=template&id=7308bfd3&scoped=true"
import script from "./ModalSuprimentos.vue?vue&type=script&lang=ts"
export * from "./ModalSuprimentos.vue?vue&type=script&lang=ts"
import style0 from "./ModalSuprimentos.vue?vue&type=style&index=0&id=7308bfd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7308bfd3",
  null
  
)

export default component.exports